function Tag(n,t,e){var r={getName:function(){return n},getUri:function(){return t},getLine:function(){return e}};return r}module.exports=Tag;